import joinClasses from "helpers/joinClasses";

export function Icon({ className = "", name = "", ...props }) {
  return <i className={joinClasses(className, `icon-${name}`)} {...props} />;
}
